import React, { Component } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import CarIcon from "src/components/icons/Car";
import MessageModal from "src/components/Modal/Components/MessageModal";
import { getAccountDisclaimer } from "src/utils/account";
import { AccountState } from "Types/state";

const TRANSLATION_KEY = "MyGarage.VehicleHeader.ExploreMore.ReserveVehicle.ReserveVehicleSuccess";

export interface ModalProps {
    closeModal: () => void;
    title: string;
    account: AccountState;
}

class ReserveVehicleSuccess extends Component<ModalProps & WithTranslation> {
    public render() {
        const { title, t, account } = this.props;
        const message = getAccountDisclaimer(account)("electric_reserve_vehicle_success")(`${TRANSLATION_KEY}.message`);
        const messageModalProps = {
            buttons: [
                {
                    onClick: this.props.closeModal,
                    text: t(`${TRANSLATION_KEY}.btnText`),
                },
            ],
            icon: CarIcon,
            logoDisplayed: true,
            message,
            title,
        };

        return (
            <div className="ReserveVehicleSuccess">
                <MessageModal {...messageModalProps} />
            </div>
        );
    }
}

export default withTranslation()(ReserveVehicleSuccess);
